//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
let d=[[[1,"Angle",0,"Expression",0],[0,"ChamferType",1,0],[1,"Faces",0,"ScCollector",0],[0,"FlipChamferOffsets",1,0],[1,"Offset1",0,"Expression",0],[1,"Offset2",0,"Expression",0]],[[[],"ResizeChamferOnMultipleBodies",{},0,0]],[]];
SPLM.Features.ResizeChamferBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.ResizeChamferBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.ResizeChamferBuilder.SectionType = Object.freeze({
    "SymmetricOffset" : "SymmetricOffset", "AsymmetricOffset" : "AsymmetricOffset", "OffsetandAngle" : "OffsetandAngle"});

export default SPLM;